import {computed, nextTick, onMounted, ref} from 'vue';
import type {TextFieldProps} from '~/types/TextFieldProps';

export function useTextField(props: TextFieldProps, element: any) {
    const isFullView = ref<boolean>(false);
    const haveHiddenText = ref<boolean>(false);

    const contentOrDash = computed<string | undefined>(() => (!props.content || !props.content.trim() ? props.replaceBy : props.content));
    const paragraphs = computed<string[]>(() => contentOrDash.value!.trim().split('\n'));
    const isCTAVisible = computed<boolean>(() => haveHiddenText.value && !!props.content);

    onMounted(() => {
        nextTick(() => {
            if (props.truncate) {
                haveHiddenText.value = element.value.offsetHeight < element.value.scrollHeight;
            }
        });
    });

    return {
        isFullView,
        isCTAVisible,
        paragraphs,
        haveHiddenText,
    };
}
